import React from "react";
import styled from "styled-components";

interface FeedbackIconProps {
  color?: string;
  size?: number | string;
}

const FeedbackIconButtonWrapper = styled.button`
  background: none;
  border: none;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  outline: none;
  cursor: pointer;
`;

// TODO: talk to brad about this type, doesn't seem to styled-components button and html button types seem to be conflicting?
export const FeedbackButton = ({
  filled = false,
  color,
  size,
  ...props
}: any) => (
  <FeedbackIconButtonWrapper {...props}>
    {filled ? (
      <FeedbackIconFilled color={color} size={size} />
    ) : (
      <FeedbackIcon color={color} size={size} />
    )}
  </FeedbackIconButtonWrapper>
);

export const FeedbackIcon: React.FC<FeedbackIconProps> = ({
  color = "black",
  size = 24,
  ...props
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g>
      <path
        d="M5.25443 13.501C5.05535 13.501 4.86442 13.4219 4.72365 13.2813C4.58288 13.1406 4.5038 12.9498 4.5038 12.7509V9.00064H2.2519C1.65482 9.00011 1.08235 8.76287 0.660151 8.341C0.237953 7.91913 0.00053003 7.3471 0 6.75048L0 2.25016C0.00053003 1.65354 0.237953 1.08151 0.660151 0.659642C1.08235 0.237769 1.65482 0.00052962 2.2519 0L21.7683 0C22.3654 0.00052962 22.9379 0.237769 23.3601 0.659642C23.7823 1.08151 24.0197 1.65354 24.0202 2.25016V6.75048C24.0197 7.3471 23.7823 7.91913 23.3601 8.341C22.9379 8.76287 22.3654 9.00011 21.7683 9.00064H10.0695L5.78588 13.2809C5.71622 13.3509 5.63339 13.4063 5.54218 13.4441C5.45096 13.4818 5.35316 13.5012 5.25443 13.501ZM2.2519 1.50011C2.05282 1.50011 1.86189 1.57913 1.72112 1.71979C1.58035 1.86045 1.50127 2.05123 1.50127 2.25016V6.75048C1.50127 7.16451 1.83755 7.50053 2.2519 7.50053H5.25443C5.45351 7.50053 5.64444 7.57956 5.78521 7.72022C5.92598 7.86088 6.00506 8.05166 6.00506 8.25059V10.9398L9.22778 7.71955C9.29737 7.64988 9.38006 7.59466 9.4711 7.55708C9.56214 7.51949 9.65972 7.50027 9.75823 7.50053H21.7683C21.9674 7.50053 22.1584 7.42151 22.2991 7.28085C22.4399 7.14019 22.519 6.94941 22.519 6.75048V2.25016C22.519 2.05123 22.4399 1.86045 22.2991 1.71979C22.1584 1.57913 21.9674 1.50011 21.7683 1.50011H2.2519Z"
        fill={color}
      />
      <path
        d="M18.7658 24.0017C18.6672 24.002 18.5695 23.9827 18.4785 23.9449C18.3874 23.9071 18.3048 23.8517 18.2354 23.7817L13.9518 19.5014H2.2519C1.65482 19.5008 1.08235 19.2636 0.660151 18.8417C0.237953 18.4199 0.00053003 17.8478 0 17.2512L0 12.7509C0.00053003 12.1543 0.237953 11.5822 0.660151 11.1604C1.08235 10.7385 1.65482 10.5013 2.2519 10.5007C2.45098 10.5007 2.6419 10.5798 2.78268 10.7204C2.92345 10.8611 3.00253 11.0519 3.00253 11.2508C3.00253 11.4497 2.92345 11.6405 2.78268 11.7812C2.6419 11.9218 2.45098 12.0008 2.2519 12.0008C2.05282 12.0008 1.86189 12.0799 1.72112 12.2205C1.58035 12.3612 1.50127 12.552 1.50127 12.7509V17.2512C1.50127 17.6652 1.83755 18.0013 2.2519 18.0013H14.262C14.4602 18.0013 14.6534 18.0813 14.7925 18.2213L18.0152 21.4415V18.7513C18.0152 18.5524 18.0943 18.3616 18.235 18.221C18.3758 18.0803 18.5667 18.0013 18.7658 18.0013H21.7683C21.9674 18.0013 22.1584 17.9222 22.2991 17.7816C22.4399 17.6409 22.519 17.4501 22.519 17.2512V12.7509C22.519 12.552 22.4399 12.3612 22.2991 12.2205C22.1584 12.0799 21.9674 12.0008 21.7683 12.0008H11.2595C11.0604 12.0008 10.8695 11.9218 10.7287 11.7812C10.5879 11.6405 10.5089 11.4497 10.5089 11.2508C10.5089 11.0519 10.5879 10.8611 10.7287 10.7204C10.8695 10.5798 11.0604 10.5007 11.2595 10.5007H21.7683C22.3654 10.5013 22.9379 10.7385 23.3601 11.1604C23.7823 11.5822 24.0197 12.1543 24.0202 12.7509V17.2512C24.0197 17.8478 23.7823 18.4199 23.3601 18.8417C22.9379 19.2636 22.3654 19.5008 21.7683 19.5014H19.5165V23.2516C19.5165 23.4506 19.4374 23.6413 19.2966 23.782C19.1558 23.9227 18.9649 24.0017 18.7658 24.0017Z"
        fill={color}
      />
    </g>
  </svg>
);

export const FeedbackIconFilled: React.FC<FeedbackIconProps> = ({
  color = "#0C68F1",
  size = 24,
  ...props
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5.118 15.286C4.97049 15.402 4.79334 15.4741 4.60679 15.4941C4.42024 15.5141 4.23181 15.4813 4.06304 15.3993C3.89428 15.3173 3.75198 15.1895 3.65242 15.0305C3.55285 14.8715 3.50003 14.6876 3.5 14.5V11.75C3.5 11.6837 3.47366 11.6201 3.42678 11.5732C3.37989 11.5263 3.3163 11.5 3.25 11.5H1.5C1.10218 11.5 0.720644 11.658 0.43934 11.9393C0.158035 12.2206 0 12.6022 0 13L0 18C0 18.3978 0.158035 18.7794 0.43934 19.0607C0.720644 19.342 1.10218 19.5 1.5 19.5H13.715C13.7762 19.4999 13.8353 19.5223 13.881 19.563L18.168 23.374C18.2401 23.438 18.3291 23.4798 18.4244 23.4944C18.5196 23.509 18.6171 23.4957 18.705 23.4562C18.7929 23.4167 18.8675 23.3526 18.9199 23.2716C18.9722 23.1907 19 23.0964 19 23V19.75C19 19.6837 19.0263 19.6201 19.0732 19.5732C19.1201 19.5263 19.1837 19.5 19.25 19.5H22.5C22.8978 19.5 23.2794 19.342 23.5607 19.0607C23.842 18.7794 24 18.3978 24 18V13C24 12.6022 23.842 12.2206 23.5607 11.9393C23.2794 11.658 22.8978 11.5 22.5 11.5H10.023C9.96691 11.5001 9.91243 11.5188 9.868 11.553L5.118 15.286Z"
      fill={color}
    />
    <path
      d="M4.75 9.5C4.8163 9.5 4.87989 9.52634 4.92678 9.57322C4.97366 9.62011 5 9.6837 5 9.75V12.5C4.99994 12.5936 5.02616 12.6854 5.0757 12.7649C5.12523 12.8443 5.19608 12.9083 5.28019 12.9494C5.36429 12.9906 5.45825 13.0073 5.55139 12.9977C5.64453 12.9881 5.73309 12.9525 5.807 12.895L10.107 9.553C10.1507 9.51892 10.2045 9.50028 10.26 9.5H22.5C22.8978 9.5 23.2794 9.34196 23.5607 9.06066C23.842 8.77936 24 8.39782 24 8V2C24 1.60218 23.842 1.22064 23.5607 0.93934C23.2794 0.658035 22.8978 0.5 22.5 0.5H1.5C1.10218 0.5 0.720644 0.658035 0.43934 0.93934C0.158035 1.22064 0 1.60218 0 2L0 8C0 8.39782 0.158035 8.77936 0.43934 9.06066C0.720644 9.34196 1.10218 9.5 1.5 9.5H4.75Z"
      fill={color}
    />
  </svg>
);
